export default __webpack_public_path__ + "static/media/icon_checkbox_indeterminate.716ddac8.svg";